import { render, staticRenderFns } from "./EconomicImpactCard.vue?vue&type=template&id=ee576bc8&scoped=true"
import script from "./EconomicImpactCard.vue?vue&type=script&lang=js"
export * from "./EconomicImpactCard.vue?vue&type=script&lang=js"
import style0 from "./EconomicImpactCard.vue?vue&type=style&index=0&id=ee576bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee576bc8",
  null
  
)

export default component.exports